<template>
    <div>
		<div :style="(deep == 0 ? '' : 'border: 1px black solid; padding:10px;')">

			<div v-if="conditions.length > 1" style="padding: 10px">
				<b-button @click="operator = 'and'" :variant="operator == 'and' ? 'success' : 'outline-success'">Et</b-button>&nbsp;
				<b-button @click="operator = 'or'" :variant="operator == 'or' ? 'success' : 'outline-success'">Ou</b-button>&nbsp;
			</div>

			<draggable handle=".handle" :list="conditions" :group="{ name: 'conditions' }" :clone="onClone" @change="onChange" @start="onStart">
				<div style="padding:0px 10px 0px 10px" v-for="(condition, idx) in conditions" :key="condition.uid">
					<rules_condition :options="options" :columns="columns" v-if="condition.type == 'condition_block' || !condition.type" :initials_data="condition" :ref="condition.uid" @remove="remove_block"></rules_condition>
					<div v-else>
						<div style="border: 1px black solid; padding:10px;">
							<h4>Condition
								<b-select style="width:200px; display: inline" @change="change_type(idx)" v-model="condition.type_action" :options="[
									{value: 'column', text: 'Colonne'},
									{value: 'line_code', text: 'Ligne de code'}
								]"></b-select>
							</h4>
							<div v-if="condition.type_action == 'line_code'">
								<b-input v-model="condition.params.code"></b-input>
							</div>
							<div v-if="condition.type_action == 'column'">
								Colonne <b-input :list="uid + '-column-' + idx" style="width:200px; display: inline" v-model="condition.params.column"></b-input> 
								&nbsp;
								<datalist :id="uid + '-column-' + idx">
									<option :key="idx" v-for="(column, idx) in columns">{{column}}</option>
								</datalist>
								<b-select style="width:200px; display: inline" v-model="condition.params.operator" :options="[
									{value: 'equal', text: 'égal à'},
									{value: 'no_equal', text: 'n\'est pas égal à'},
									{value: 'contain', text: 'contient'},
									{value: 'no_contain', text: 'ne contient pas'},
									{value: 'lower', text: 'plus petit que'},
									{value: 'lower_equal', text: 'plus petit ou égal que'},
									{value: 'greater', text: 'plus grand que'},
									{value: 'greater_equal', text: 'plus grand ou égal que'},
								]"></b-select>
								&nbsp;
								<b-input :list="uid + '-value-' + idx" style="width:200px; display: inline" v-model="condition.params.value"></b-input>
								<datalist v-if="options.columns_list[condition.params.column]" :id="uid + '-value-' + idx">
									<option :key="idx" v-for="(column, idx) in options.columns_list[condition.params.column]">{{column}}</option>
								</datalist>
							</div>
							<b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
							<b-button variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
							<b-button variant="link" @click="setInverse(idx)" ><b-checkbox style="display: inline" @click.native.prevent v-model="condition.inverse">!</b-checkbox></b-button>
						</div>
					</div>
				</div>
			</draggable>

			<b-button variant="link" @click="addBlock('condition_block')"><i class="fas fa-plus"></i> groupe</b-button>
			<b-button variant="link" @click="addBlock('condition')"><i class="fas fa-plus"></i> condition</b-button>
			<b-button variant="link" @click="inverse = inverse ? false : true" ><b-checkbox style="display: inline" @click.native.prevent v-model="inverse">!</b-checkbox></b-button>

			<span v-if="deep != 0">
				<b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
				<b-button variant="link" @click="del()"><i class="fas fa-trash"></i></b-button>
			</span>
		</div>
    </div>
</template>

<script>
	import draggable from "vuedraggable";
	
    var clone = require("clone");
    const _ = require("underscore");

	export default {
		name: "rules_condition",
		components: {
			draggable
		},
		data() {
			return {
				uid: this.$uuid.v4(),
				deep: 0,
				operator: "and",
				conditions: [],
				inverse: false
            }
		},
		props: {
			library: {
				default: false
			},
			initials_data: {
				type: Object,
				default() {
					return {}
				}
			},
			columns: {
				type: Array,
				default() {
					return []
				}
			},
			options: {
				type: Object,
				default() {
					return {}
				}
			}
		},
		computed: {
		},
        methods: 
        {
			onClone(data)
			{
				var uid = data.uid;
				this.save();
				for (var i = 0; i < this.conditions.length; i++)
				{
					if (this.conditions[i].uid == uid)
					{
						return clone(this.conditions[i]);
					}
				}
			},
			onChange(evt)
			{
			},
			onStart(evt)
			{
			},
			async load(data)
			{
				//console.log("data")
				//console.log(data)
				var self = this;
				
				if (data.uid)
					this.uid = data.uid;
				if (data.name)
					this.name = data.name;
				if (data.operator)
					this.operator = data.operator;
				if (data.conditions)
					this.conditions = data.conditions;
				if (data.deep)
					this.deep = data.deep;

				if (data.inverse)
					this.inverse = data.inverse;

                /*self.$nextTick(async function () {
                });*/
			},
			save()
            {
				var conditions = [];
				for (var i = 0; i < this.conditions.length; i++)
				{
					if (this.conditions[i].type == 'condition_block' || !this.conditions[i].type)
					{
						var block = this.$refs[this.conditions[i].uid][0].save();
						conditions.push(block)
					}
					else
						conditions.push(this.conditions[i]);
				}

				this.conditions = conditions;

				return {
					name: this.name,
					uid: this.uid,
					deep: this.deep,
					operator: this.operator,
					conditions: conditions,
					inverse: this.inverse
				}
			},
			async addBlock(type)
			{
				if (type == "condition_block")
				{
					this.conditions.push({
						deep: this.deep + 1,
						uid: this.$uuid.v4(),
						type: type,
						operator: "and"
					})
				}
				else
				{
					this.conditions.push({
						deep: this.deep + 1,
						uid: this.$uuid.v4(),
						type: type,
						type_action: "column",
						params: { 
							value: "",
							operator: "equal",
							column: ""
						}
					})
				}
			},
			change_type(idx)
			{
				switch (this.conditions[idx].type_action)
				{
					case "line_code":
						this.conditions[idx].params = { code: ""};
						break;
					case "column":
						this.conditions[idx].params = { 
							value: "",
							operator: "equal",
							column: ""
						};
						break;
				}
			},
			setInverse(idx)
			{
				this.$set(this.conditions[idx], "inverse", this.conditions[idx].inverse ? false : true);
			},
			del(idx = null)
			{
				if (idx != null)
					this.conditions.splice(idx, 1);
				else
					this.$emit("remove", this.uid, true);
			},
			remove_block(uid)
			{
				for (var i = 0; i < this.conditions.length; i++)
				{
					if (this.conditions[i].uid == uid)
					{
						this.conditions.splice(i, 1);
						break;
					}
				}
			},
			async generate_code()
			{
				var code = "(";

				if (this.inverse)
					code += "!(";

				for (var i = 0; i < this.conditions.length; i++)
				{
					if (i)
					{
						if (this.operator == "and")
							code += " && ";
						if (this.operator == "or")
							code += " || ";
					}

					if (this.conditions[i].inverse)
						code += "!("

					if (this.conditions[i].type == 'condition_block' || !this.conditions[i].type)
					{
						code += await this.$refs[this.conditions[i].uid][0].generate_code();
					}
					else
					{
						if (this.conditions[i].type_action == "line_code")
						{
							code += this.conditions[i].params.code + " ";
						}
						else if (this.conditions[i].type_action == "column")
						{
							var lowercase = ""
							if (this.options.lowercase)
								lowercase = ".toLowerCase()";
							switch (this.conditions[i].params.operator)
							{
								case "equal":
									code += 'data["' + this.conditions[i].params.column.replace(/"/g, '\\"') + '"]' + lowercase + ' == "' + this.conditions[i].params.value.replace(/"/g, '\\"') + '"' + lowercase + '';
									break;
								case "no_equal":
									code += 'data["' + this.conditions[i].params.column.replace(/"/g, '\\"') + '"]' + lowercase + ' != "' + this.conditions[i].params.value.replace(/"/g, '\\"') + '"' + lowercase + '';
									break;
								case "contain":
									code += 'data["' + this.conditions[i].params.column.replace(/"/g, '\\"') + '"]' + lowercase + '.includes("' + this.conditions[i].params.value.replace(/"/g, '\\"') + '"' + lowercase + ')';
									break;
								case "no_contain":
									code += '!data["' + this.conditions[i].params.column.replace(/"/g, '\\"') + '"]' + lowercase + '.includes("' + this.conditions[i].params.value.replace(/"/g, '\\"') + '"' + lowercase + ')';
									break;
								case "lower":
									code += 'parseFloat(data["' + this.conditions[i].params.column.replace(/"/g, '\\"') + '"]) < parseFloat("' + this.conditions[i].params.value.replace(/"/g, '\\"') + '")';
									break;
								case "lower_equal":
									code += 'parseFloat(data["' + this.conditions[i].params.column.replace(/"/g, '\\"') + '"]) <= parseFloat("' + this.conditions[i].params.value.replace(/"/g, '\\"') + '")';
									break;
								case "greater":
									code += 'parseFloat(data["' + this.conditions[i].params.column.replace(/"/g, '\\"') + '"]) > parseFloat("' + this.conditions[i].params.value.replace(/"/g, '\\"') + '")';
									break;
								case "greater_equal":
									code += 'parseFloat(data["' + this.conditions[i].params.column.replace(/"/g, '\\"') + '"]) >= parseFloat("' + this.conditions[i].params.value.replace(/"/g, '\\"') + '")';
									break;
							}
						}
					}
					if (this.conditions[i].inverse)
						code += ")"
				}

				if (this.inverse)
					code += ")";

				code += ")"

				return code;
			}
		},
		mounted: async function () {
            var self = this;
	
			if (this.initials_data)
				this.load(clone(this.initials_data));
		},
	};
</script>

<style>
.is-hidden {
    display: none;
}
</style>
